<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('client') }}</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label>{{ $t('surname') }}</label>
              <input type="text" :placeholder="$t('surname')" v-model="user.middleName">
              <span class="error" v-if="errors.middlename">{{ errors.middlename[0] }}</span>
            </div>
            <div class="form-group">
              <label>{{ $t('name') }}</label>
              <input type="text" :placeholder="$t('name')" v-model="user.firstName">
              <span class="error" v-if="errors.firstname">{{ errors.firstname[0] }}</span>
            </div>
            <div class="form-group">
              <label>{{ $t('lastname') }}</label>
              <input type="text" :placeholder="$t('lastname')" v-model="user.lastName">
              <span class="error" v-if="errors.lastname">{{ errors.lastname[0] }}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>{{ $t('phone') }}</label>
              <masked-input v-model="user.phone" mask="\+\7 111 111 1111" :placeholder="$t('phone')"/>
              <div class="phone-add" @click="addPhone">
                <i class="fas fa-plus"></i>
              </div>
              <span class="error" v-if="errors.phone">{{ errors.phone[0] }}</span>
            </div>
            <div class="form-group">
              <label>Email</label>
              <input type="email" placeholder="Email" v-model="user.email">
              <span class="error" v-if="errors.email">{{ errors.email[0] }}</span>
            </div>
          </div>
          <div class="social-block mb-5">
            <div class="social-item">
              <div class="social-img"><img src="@/assets/social/telegram.svg"></div>
              <div class="social-label"><label>Telegram</label></div>
              <div class="social-radio">
                <input class="radio_input" id="Telegram" type="radio" :checked="this.user.telegram" :disabled="true">
                <label class="radio_label" for="Telegram"></label>
              </div>
            </div>

            <div class="social-item">
              <div class="social-img"><img src="@/assets/social/viber.svg"></div>
              <div class="social-label"><label>Viber</label></div>
              <div class="social-radio">
                <input class="radio_input" id="Viber" type="radio" :checked="this.user.viber" :disabled="true">
                <label class="radio_label" for="Viber"></label>
              </div>
            </div>

            <div class="social-item">
              <div class="social-img"><img src="@/assets/social/sms.svg"></div>
              <div class="social-label"><label>SMS</label></div>
              <div class="social-radio">
                <input class="radio_input" id="sms" type="radio" :checked="this.user.phones.length > 0" :disabled="true">
                <label class="radio_label" for="sms"></label>
              </div>
            </div>

            <div class="social-item">
              <div class="social-img"><img src="@/assets/social/email.svg"></div>
              <div class="social-label"><label>Email</label></div>
              <div class="social-radio">
                <input class="radio_input" id="email" type="radio" :checked="this.user.email" :disabled="true">
                <label class="radio_label" for="email"></label>
              </div>
            </div>

          </div>
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">№</th>
              <th scope="col">Телефон</th>
              <th scope="col">Действие</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in user.phones">
              <th scope="row">
                {{ index + 1 }}
              </th>
              <td>
                {{ item.phone }}
              </td>
              <td>
                <i class="fas fa-times" @click="removePhone(index, item.phone)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">{{ $t('close') }}</button>
          <button type="button" class="btn btn-primary" @click="updateClientInfo">{{ $t('save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import maskedInput from "vue-masked-input";
export default {
  name: 'client-modal',
  props: ['id'],
  data: function(){
    return{
      user: {
        uid: this.id,
        middleName: null,
        firstName: null,
        lastName: null,
        phones: [],
        phone: '',
        email: null,
        telegram: null,
        viber: null,
      },
      phonesLength: 0,
      errors: [],
    }
  },
  watch: {
    id: function (val) {
      if(val > 0){
        this.user.uid = val;
        this.getClientInfo();
      }
    },
  },
  methods: {
    removePhone: function(index, phone){
      console.log(index)
      if(this.phonesLength >= index){
        var data = {
          phone: phone,
        }
        axios.post('deletePhone', data).then(response => {
          var status = response.data.status;
          if(status){
            this.user.phones.splice(index, 1);
            this.$toast.success("Телефон успешно удален");
            this.$root.$emit('updateClients');
          }
        });
      }else{
        this.user.phones.splice(index, 1);
      }
    },
    addPhone: function(){
      let phone = this.user.phone.replaceAll('_', '').replaceAll(' ', '');
      if(phone.length === 12){
        this.user.phones.push({
          phone: phone,
        });
        this.user.phone = '';
      }else{
        this.$toast.warning("Ошибочный формат телефона");
      }
    },
    close: function() {
      this.$emit('close');
    },
    getClientInfo: function(){
      axios.post('getClient', this.user).then(response => {
        var status = response.data.status;
        if(status){
          this.user.middleName = response.data.client.middlename;
          this.user.firstName = response.data.client.firstname;
          this.user.lastName = response.data.client.lastname;
          this.user.phones = response.data.client.phone == null ? [] : response.data.client.phone;
          this.user.email = response.data.client.email;
          this.user.telegram = response.data.client.telegram;
          this.user.viber = response.data.client.viber;
          this.convertPhone();
        }
      });
    },
    convertPhone: function(){
      var obj = [];
      if(!!this.user.phones && this.user.phones.length){
        this.user.phones = this.user.phones.split(',');

        this.user.phones.forEach((value, index) => {
          obj.push({phone: value});
        });

        this.user.phones = obj;
        this.phonesLength = obj.length - 1;
      }
    },
    updateClientInfo: function(){
      axios.post('updateClient', this.user).then(response => {
        var status = response.data.status;
        if(status){
          this.$toast.success("Информация успешно сохранена");
          this.errors = [];
          this.getClientInfo();
          this.$emit('close');
          this.$root.$emit('updateSegments');
          this.$root.$emit('updateClients');
        }else{
          this.errors = response.data.errors;
          this.getClientInfo();
        }
      });
    },
  },
  components: {
    maskedInput,
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}

</style>